module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/34.18a3b100.png";